import { useActiveOrganizationId } from "@/contexts"
import { ApiQueryName } from "@/models/api"
import type { Organization } from "@/models/organization"
import type { ISitePreview } from "@/models/site"
import { useRenameQueryResult } from "@/services/utils"
import { useQuery } from "@tanstack/react-query"

import type { UseApiOptions } from "../types"
import { useQueryKey } from "../utils/useQueryKey"
import { fetchSitePreviewsByOrgId } from "./useSitePreviewsUtils"

interface UseSitePreviewsApiQueryOptions {
  organizationId: Organization["id"]
}

export const useSitePreviews = (
  options: UseApiOptions<UseSitePreviewsApiQueryOptions, ISitePreview[]> = {}
) => {
  const { apiQueryOptions, queryOptions = {} } = options

  const { activeOrganizationId } = useActiveOrganizationId()

  const organizationId =
    apiQueryOptions?.organizationId ?? activeOrganizationId ?? ""

  const queryKey = useQueryKey(
    ApiQueryName.SitePreviews,
    "getMany",
    organizationId
  )
  const queryResult = useQuery({
    ...queryOptions,
    enabled: Boolean(organizationId) && (queryOptions.enabled ?? true),
    queryFn: () => fetchSitePreviewsByOrgId({ orgId: organizationId ?? "" }),
    queryKey,
  })

  return useRenameQueryResult(queryResult, ApiQueryName.SitePreviews)
}
